import { action, observable, makeObservable } from 'mobx';
import PLPConstants from '../components/Brand/ProductListingPage/constants';
import { Product, FacetCategory, Filter } from './models/PLP_Model';
import getFilteredData from '../utils/getFilteredData';
import { customJsonstringify } from '../utils/helpers/customJsonstringify.helpers';

class PLPStore {
  product_list = [];
  url_hash_filter;
  previous_url_hash_filter;
  current_url_filter_string;
  url_sort_filter;
  initial_page;
  pageSlug = '';
  product_list_arr_objs = [];
  previous_data = [];
  next_data = [];
  selected_product_ids = [];
  locale;
  pageData;

  initial_products = [];
  current_page;
  lazyLoad = { ...PLPConstants.lazy_load_consts };
  recent_applied_facet_category = '';

  /**=============== Product filter ===============*/
  filters = [];
  selectedFilters = [];

  facet_category_list = [];

  product_section_loader = false;
  load_more_display_state = true;
  url_hash_string = '';
  href = '';
  previous_query = '';
  totalProdCount = 0;

  /**===== set products into store ====*/
  setInitialProductList = products => {
    this.initial_products = products;
  };

  /**  check, is product already been selected before */
  checkIsSelected = product => {
    if (
      this.selected_product_ids.length &&
      product.hasOwnProperty('gtin') &&
      this.selected_product_ids.indexOf(product.gtin) > -1
    ) {
      return true;
    }
    return;
  };

  setProducts = (
    previous_sort_filter,
    previous_url_hash,
    previous_url_hash_filter,
    url_hash_string,
    products_list,
    data_source_mode
  ) => {
    let product_list = [];
    if (
      previous_url_hash_filter !== this.url_hash_filter ||
      previous_url_hash_filter === null ||
      this.url_hash_filter === null ||
      previous_sort_filter !== this.applyedFilterList[0].sort
    ) {
      this.product_list_arr_objs = [];
    }

    if (typeof this.applyedFilterList[0].page == 'string') {
      this.applyedFilterList[0].page = parseInt(this.applyedFilterList[0].page);
    }

    if (PLPConstants.data_source_mode_option.API_DATA === data_source_mode) {
      for (let index = 0; index < products_list.length; index++) {
        const product = products_list[index];
        const product_object = {
          id: product.gtin,
          title: product.productShortName,
          image: {
            url: product.heroImage,
            description: product?.heroImageDescription,
          },
          link: product.slug,
          rating: product.rating,
          description: product.shortDescription,
          ratingCount: product.total_review_count,
          callToActions: null,
          checked: this.checkIsSelected(product),
          ratingAndReviewId: product.ratingAndReviewId,
          productCategoryType: product.productCategoryType,
          variantsgtin: product.variantsgtin,
        };
        product_list.push(product_object);
      }
    } else {
      /*** data from contentful **/

      for (let index = 0; index < products_list.length; index++) {
        const product = products_list[index];

        let productName = '';
        if (
          product.hasOwnProperty('productShortName') &&
          product.productShortName
        ) {
          productName = product.productShortName;
        } else {
          productName = product.productName;
        }
        product_list.push(
          new Product(
            product.gtin,
            productName,
            product.heroImage,
            product.heroImageDescription,
            product.slug,
            product.rating,
            product.shortDescription,
            product.ratingCount,
            this.checkIsSelected(product),
            product.ratingAndReviewId,
            product.productCategoryType
          )
        );
      }
    }

    let pageWiseProductsObj = {
      products: product_list,
      pageNumber:
        typeof this.applyedFilterList[0].page == 'string'
          ? parseInt(this.applyedFilterList[0].page)
          : this.applyedFilterList[0].page,
      itemUrl: url_hash_string,
    };
    if (this.current_page > this.applyedFilterList[0].page) {
      this.product_list_arr_objs = [
        pageWiseProductsObj,
        ...this.product_list_arr_objs,
      ];
    } else {
      this.product_list_arr_objs = [
        ...this.product_list_arr_objs,
        pageWiseProductsObj,
      ];
    }
    this.product_list = [...this.product_list_arr_objs];
    this.product_section_loader = false;
  };

  setProductFilterCategories = (filter_categories = []) => {
    let strFilter = {
      facetCategories: [],
    };
    strFilter.facetCategories = filter_categories.map(fc => {
      let facetCategory = new FacetCategory(fc);

      /**
       * facet categories list
       */
      if (fc.uniqueId != null && fc.uniqueId != '') {
        this.facet_category_list.push(fc.uniqueId);
      }

      if (fc.facet) {
        facetCategory.facet = fc.facet.map(f => {
          return new Filter({
            ...f,
            facet_category: fc.uniqueId,
          });
        });
      }
      return facetCategory;
    });
    this.filters = strFilter;
  };

  /**
   * Add filter on select from list and added to chip section
   */

  applyedFilterList = [...PLPConstants.filter_list];

  resetApplyedFilters = () => {
    this.applyedFilterList = [...PLPConstants.filter_list];
  };

  /**====  Handle change sort for product list ===*/
  addSorting = async sortBy => {
    this.applyedFilterList[0].sort = sortBy;
    await this.getfilterQuery();
    return this.product_list;
  };

  handlePagination = async () => {
    this.current_page = this.applyedFilterList[0].page;
    if (this.load_more_display_state) {
      this.applyedFilterList[0].page = ++this.applyedFilterList[0].page;

      await this.getfilterQuery();
      return this.product_list;
    }
  };
  handlePaginationReverse = async () => {
    this.current_page = this.applyedFilterList[0].page;
    if (this.applyedFilterList[0].page > 1) {
      this.applyedFilterList[0].page = --this.applyedFilterList[0].page;
      await this.getfilterQuery();
      return this.product_list;
    }
  };

  addFilters = async (filter, filterType) => {
    this.recent_applied_facet_category = filter.facet_category;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    filter.selected = true;
    this.selectedFilters.push(filter);

    /**
     * Manage selected facet and its parenet category
     */
    if (this.applyedFilterList[0].filter.hasOwnProperty(filterType.title)) {
      this.applyedFilterList[0].filter[filterType.title].push(
        filter.title.trim()
      );
    } else {
      this.applyedFilterList[0].filter[filterType.title] = [
        filter.title.trim(),
      ];
    }
    await this.getfilterQuery();
    return this.product_list;
  };
  addFiltersWithoutQuery = (filter, filterType) => {
    this.recent_applied_facet_category = filter.facet_category;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    filter.selected = true;
    this.selectedFilters.push(filter);

    /**
     * Manage selected facet and its parenet category
     */
    if (this.applyedFilterList[0].filter.hasOwnProperty(filterType.title)) {
      this.applyedFilterList[0].filter[filterType.title].push(
        filter.title.trim()
      );
    } else {
      this.applyedFilterList[0].filter[filterType.title] = [
        filter.title.trim(),
      ];
    }
  };

  redirectOnFilters = () => {
    this.getfilterQuery();
    if (typeof window !== 'undefined') {
      window.location.href = this.href;
    }
  };

  AddFiltersOnRadio = (filter, filterType) => {
    this.recent_applied_facet_category = filter.facet_category;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    filter.selected = true;
    this.selectedFilters.push(filter);

    /**
     * Manage selected facet and its parenet category
     */
    if (this.applyedFilterList[0].filter.hasOwnProperty(filterType.title)) {
      this.applyedFilterList[0].filter[filterType.title].push(
        filter.title.trim()
      );
    } else {
      this.applyedFilterList[0].filter[filterType.title] = [
        filter.title.trim(),
      ];
    }

    this.url_hash_string = this.generateUrlFromFilter();
    let url = window.location.href.replace(/\/\s*$/, '');
    let asPath;

    if (url.indexOf('?') > -1) {
      url = url.split('?');

      asPath = url[0];
    } else {
      asPath = url;
    }
    let asPathArr = asPath.split('/');
    asPathArr.pop();
    asPathArr.push(filter.slug.trim());
    asPath = asPathArr.join('/');
    this.href = asPath; //+ '#' + this.url_hash_string;
  };

  addFiltersAndRedirect = (filter, filterType) => {
    this.recent_applied_facet_category = filter.facet_category;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    filter.selected = true;
    this.selectedFilters.push(filter);

    /**
     * Manage selected facet and its parenet category
     */
    if (this.applyedFilterList[0].filter.hasOwnProperty(filterType.title)) {
      this.applyedFilterList[0].filter[filterType.title].push(
        filter.title.trim()
      );
    } else {
      this.applyedFilterList[0].filter[filterType.title] = [
        filter.title.trim(),
      ];
    }
    this.getfilterQuery();
    this.url_hash_string = this.generateUrlFromFilter();
    let url = window.location.href.replace(/\/\s*$/, '');
    let asPath;

    if (url.indexOf('?') > -1) {
      url = url.split('?');

      asPath = url[0];
    } else {
      asPath = url;
    }
    let asPathArr = asPath.split('/');
    asPathArr.pop();
    asPathArr.push(filter.slug.trim());
    asPath = asPathArr.join('/');
    this.href = asPath; //+ '#' + this.url_hash_string;
    if (typeof window !== 'undefined') {
      window.location.href = this.href;
    }
  };

  /**
   * Clear specific active filters
   * Restore chips and specific filter element into list
   */

  clearFilterWithoutQuery = (filter, filterType) => {
    this.recent_applied_facet_category = filter.facet_category;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    filter.selected = false;
    this.selectedFilters = this.selectedFilters.filter(f => f.id !== filter.id);
    /**
     * remove facet from selected filter list
     */

    const category =
      filterType.title == filter.title
        ? filter.facet_category
        : filterType.title;

    let appliedFilter = this.applyedFilterList[0].filter;

    if (
      appliedFilter.hasOwnProperty(category) &&
      appliedFilter[category].length === 1
    ) {
      delete this.applyedFilterList[0].filter[category];
    } else if (
      appliedFilter.hasOwnProperty(category) &&
      appliedFilter[category].length
    ) {
      const facetIndex = this.applyedFilterList[0].filter[category].indexOf(
        filter.title
      );
      if (facetIndex > -1) {
        this.applyedFilterList[0].filter[category].splice(facetIndex, 1);
      }
    }
  };

  clearFilter = async (filter, filterType) => {
    this.recent_applied_facet_category = filter.facet_category;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    filter.selected = false;
    this.selectedFilters = this.selectedFilters.filter(f => f.id !== filter.id);
    /**
     * remove facet from selected filter list
     */

    const category =
      filterType.title == filter.title
        ? filter.facet_category
        : filterType.title;

    let appliedFilter = this.applyedFilterList[0].filter;

    if (
      appliedFilter.hasOwnProperty(category) &&
      appliedFilter[category].length === 1
    ) {
      delete this.applyedFilterList[0].filter[category];
    } else if (
      appliedFilter.hasOwnProperty(category) &&
      appliedFilter[category].length
    ) {
      const facetIndex = this.applyedFilterList[0].filter[category].indexOf(
        filter.title
      );

      if (facetIndex > -1) {
        this.applyedFilterList[0].filter[category].splice(facetIndex, 1);
      }
    }
    await this.getfilterQuery();
    return this.product_list;
  };

  /**
   * Clear all active filters
   * restore chips and filter list
   */

  clearFilterByCategory = filterType => {
    this.recent_applied_facet_category = filterType.uniqueId;
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    this.filters.facetCategories.map(facetCategory => {
      if (facetCategory.title === filterType.uniqueId) {
        facetCategory.facet.map(facet => {
          facet.selected = false;
        });
      }
    });

    this.selectedFilters = this.selectedFilters.filter(
      f => f.facet_category !== filterType.uniqueId
    );
    /**
     * remove facet from selected filter list
     */

    const category = filterType.uniqueId;

    delete this.applyedFilterList[0].filter[category];
  };

  resetFilterByCategory = filterType => {
    this.recent_applied_facet_category = filterType ? filterType.uniqueId : '';
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;
    this.filters.facetCategories.map(facetCategory => {
      if (
        !filterType ||
        (filterType && facetCategory.title !== filterType.uniqueId)
      ) {
        facetCategory.facet.map(facet => {
          facet.selected = false;
        });
      }
    });

    this.selectedFilters.map(f => {
      !filterType || (filterType && f.facet_category !== filterType.uniqueId)
        ? delete this.applyedFilterList[0].filter[f.facet_category]
        : null;
    });
    this.selectedFilters = this.selectedFilters.filter(
      f => filterType && f.facet_category === filterType.uniqueId
    );
    /**
     * remove facet from selected filter list
     */
  };

  clearAllFilter = () => {
    this.recent_applied_facet_category = '';
    this.load_more_display_state = true;
    this.applyedFilterList[0].page = 1;

    this.selectedFilters.forEach(fc => {
      fc.selected = false;
    });

    this.selectedFilters = [];
    /**
     * reset all the selected facet
     */

    this.applyedFilterList[0].filter = {};

    this.getfilterQuery();
  };

  /**
   * add filter to apply filter list based on hash
   */
  setFilter = (url, hash, reset = false) => {
    let filter_object = { ...PLPConstants.filter_list[0] };
    if (reset) {
      this.resetApplyedFilters();
    }
    if (hash == '' && this.pageData.facetCategory !== undefined) {
      this.applyedFilterList[0].filter = filter_object.filter;
      let pageNumber = url.split('-page-')[1];
      if (pageNumber !== undefined) {
        this.applyedFilterList[0].page = parseInt(pageNumber);
      }
    }
    if (hash == '' && this.pageData.facetCategory != null) {
      let facet = {
        [this.pageData.facetCategory.uniqueId]: [this.pageData.facet.name],
      };
      filter_object.filter = facet;
      this.applyedFilterList[0].filter = filter_object.filter;
      let pageNumber = url.split('-page-')[1];
      if (pageNumber !== undefined) {
        this.applyedFilterList[0].page = parseInt(pageNumber);
      }
    } else if (
      hash != '' &&
      !hash.includes('facet') &&
      this.pageData.facetCategory != null
    ) {
      let facet = {
        [this.pageData.facetCategory.uniqueId]: [this.pageData.facet.name],
      };
      filter_object.filter = facet;
      this.applyedFilterList[0].filter = filter_object.filter;
      const url_list = hash.split('&');
      url_list.forEach(obj => {
        const data_array = obj.split('=');
        if (data_array['0'] == 'page') {
          this.applyedFilterList[0].page =
            data_array.length > 1 ? data_array[1] : 1;
        }
      });
    } else if (
      hash != '' &&
      !hash.includes('facet') &&
      this.pageData.facetCategory == null
    ) {
      const url_list = hash.split('&');
      url_list.forEach(obj => {
        const data_array = obj.split('=');
        if (data_array['0'] == 'page') {
          this.applyedFilterList[0].page =
            data_array.length > 1 ? data_array[1] : 1;
        }
      });
    } else if (hash != '') {
      const url_list = hash.split('&');
      url_list.forEach(obj => {
        const data_array = obj.split('=');
        if (data_array.length) {
          if (data_array[0] == 'facet') {
            const facet_array = data_array[1].split(',');
            facet_array.forEach(entity => {
              const entity_object = entity.split(':');
              filter_object.filter[entity_object[0]] = entity_object[1].split(
                '|'
              );
            });
            this.applyedFilterList[0].filter = filter_object.filter;
          } else if (data_array[0] == 'sort') {
            this.applyedFilterList[0].sort =
              data_array.length > 1 ? data_array[1] : null;
          } else if (data_array['0'] == 'page') {
            this.applyedFilterList[0].page =
              data_array.length > 1 ? data_array[1] : 1;
          }
        }
      });
    }
    this.applyFilter();
  };

  constructor() {
    makeObservable(this, {
      product_list: observable,
      url_hash_filter: observable,
      previous_url_hash_filter: observable,
      current_url_filter_string: observable,
      url_sort_filter: observable,
      initial_page: observable,
      pageSlug: observable,
      product_list_arr_objs: observable,
      previous_data: observable,
      next_data: observable,
      selected_product_ids: observable,
      locale: observable,
      pageData: observable,
      current_page: observable,
      lazyLoad: observable,
      recent_applied_facet_category: observable,
      filters: observable,
      selectedFilters: observable,
      facet_category_list: observable,
      product_section_loader: observable,
      load_more_display_state: observable,
      url_hash_string: observable,
      href: observable,
      previous_query: observable,
      totalProdCount: observable,
      setInitialProductList: action,
      checkIsSelected: action,
      setProducts: action,
      setProductFilterCategories: action,
      resetApplyedFilters: action,
      addSorting: action,
      handlePagination: action,
      handlePaginationReverse: action,
      addFilters: action,
      redirectOnFilters: action,
      AddFiltersOnRadio: action,
      addFiltersAndRedirect: action,
      clearFilterWithoutQuery: action,
      clearFilter: action,
      clearFilterByCategory: action,
      resetFilterByCategory: action,
      clearAllFilter: action,
      setFilter: action,
      applyFilter: action,
      applyDefaultFilter: action,
      filterUrlString: action,
      algoliaQuery: observable,
      generateUrlFromFilter: action,
      getfilterQuery: action,
      getInitialFacetCount: action,
      setUrlhashString: action,
      setFacetCount: action,
      resetStore: action
    });
  }

  /**
   *  Apply default filter on page load
   */
  applyFilter() {
    let filter_categories = Object.keys(this.applyedFilterList[0].filter);
    this.filters.facetCategories != null &&
      this.filters.facetCategories.forEach(category => {
        if (filter_categories.indexOf(category.title) > -1) {
          category.facet.forEach(facet => {
            if (
              this.applyedFilterList[0].filter.hasOwnProperty(category.title) &&
              this.applyedFilterList[0].filter[category.title].indexOf(
                facet.title
              ) > -1
            ) {
              facet.selected = true;

              let isDuplicate = false;
              this.selectedFilters.forEach(object => {
                if (object.title == facet.title) {
                  isDuplicate = true;
                  return;
                }
              });

              if (!isDuplicate) {
                this.selectedFilters.push(facet);
              }
            } else {
              facet.selected = false;
            }
          });
        }
      });
    this.getfilterQuery();
  }

  applyDefaultFilter() {
    let filter_categories = Object.keys(this.applyedFilterList[0].filter);
    this.filters.facetCategories != null &&
      this.filters.facetCategories.forEach(category => {
        if (filter_categories.indexOf(category.title) > -1) {
          category.facet.forEach(facet => {
            if (
              this.applyedFilterList[0].filter.hasOwnProperty(category.title) &&
              this.applyedFilterList[0].filter[category.title].indexOf(
                facet.title
              ) > -1
            ) {
              facet.selected = true;

              let isDuplicate = false;
              this.selectedFilters.forEach(object => {
                if (object.title == facet.title) {
                  isDuplicate = true;
                  return;
                }
              });

              if (!isDuplicate) {
                this.selectedFilters.push(facet);
              }
            } else {
              facet.selected = false;
            }
          });
        }
      });
  }

  filterUrlString = filter => {
    let query_string = '';
    Object.keys(filter).forEach(attribute => {
      let facet_string = '';
      filter[attribute].forEach((facet, index) => {
        facet_string +=
          index == filter[attribute].length - 1 ? facet : facet + '|';
      });
      const uniqueId =
        this.pageData.facetCategory && this.pageData.facetCategory.uniqueId;
      if (attribute != uniqueId) {
        if (facet_string != '') {
          if (query_string == '') {
            query_string += 'facet=';
          }
          query_string += `${attribute + ':' + facet_string},`;
        }
      } else if (this.pageData.facetCategory == null) {
        if (facet_string != '') {
          if (query_string == '') {
            query_string += 'facet=';
          }
          query_string += `${attribute + ':' + facet_string},`;
        }
      }
    });
    return query_string.replace(/,\s*$/, '');
  };

  algoliaQuery = { ...PLPConstants.algoliaQueryFormat };

  generateUrlFromFilter = () => {
    const url_hash_filter_string = encodeURI(
      this.filterUrlString(this.applyedFilterList[0].filter)
    );
    this.url_hash_filter = url_hash_filter_string;
    const url_hash_sort_string = encodeURI(
      this.applyedFilterList[0].sort != null
        ? `${'sort=' + this.applyedFilterList[0].sort}`
        : ''
    );
    this.url_sort_filter = this.applyedFilterList[0].sort;
    const url_hash_page_string =
      this.applyedFilterList[0].page && this.applyedFilterList[0].page >1 
        ? `${'page=' + this.applyedFilterList[0].page}`
        : '';

    let url_hash_string = '';

    if (url_hash_filter_string.length) {
      url_hash_string = url_hash_filter_string;
    }

    if (url_hash_sort_string.length) {
      url_hash_string +=
        (url_hash_string.length ? '&' : '') + url_hash_sort_string;
    }
    if (url_hash_page_string.length) {
      url_hash_string +=
        (url_hash_string.length ? '&' : '') + url_hash_page_string;
    }
    return url_hash_string;
  };

  getfilterQuery = async () => {
    this.product_section_loader = false;
    this.previous_data = this.product_list;
    this.previous_url_hash_filter = this.url_hash_filter;
    let previous_url_hash_string = this.url_hash_string;
    let previous_url_hash_filter = this.url_hash_filter;
    let previous_sort_filter = this.url_sort_filter;
    this.load_more_display_state = true;
    let url_hash_string = this.generateUrlFromFilter();
    this.current_url_filter_string = this.url_hash_filter;
    /*get data from swiftype*/

    let product_search_query = Object.assign({}, this.algoliaQuery);
    if (this.applyedFilterList[0].filter.length == '0') {
      this.recent_applied_facet_category = '';
    }
    /*** filter query **/
    product_search_query.filters = this.applyedFilterList[0]?.filter
    /*** sorting */
    let current_sorting_constants = PLPConstants.sorting_dropdown_list['newest'];
    if (this.applyedFilterList[0].sort) 
      current_sorting_constants =
        PLPConstants.sorting_dropdown_list[this.applyedFilterList[0].sort];
  
    /**
     * apply Pagination into query
     */
    product_search_query.hitsPerPage = this.lazyLoad.per_page;
    product_search_query.page = this.applyedFilterList[0].page-1;
    /**
     * facet category list added to query to get product count on facet
     */

    product_search_query.facets = this.facet_category_list;

    /**
     *  Trigger swiftype query
     */
    this.product_section_loader = true;

    this.previous_query = customJsonstringify(product_search_query);

    await getFilteredData(this.initial_products,{...product_search_query,...current_sorting_constants})
      .then((data) => {
          this.product_section_loader = false;
          this.totalProdCount = data.nbHits;
          if (data.page >= data.nbPages-1) {
            this.load_more_display_state = false;
          }
          let updated_product_list = data.hits;

          const facet_count_object = data.facets;
           this.setFacetCount(facet_count_object);
          // updated_product_list = updated_product_list.map(p => {
          //   return {
          //     ...p,
          //   };
          // });
          this.setProducts(
            previous_sort_filter,
            previous_url_hash_string,
            previous_url_hash_filter,
            url_hash_string,
            updated_product_list,
            PLPConstants.data_source_mode_option.API_DATA
          );

      })
      .catch(() => {
        this.product_section_loader = false;
      });

    /** Get facet count for current applied category */

    let count_filter_query = {
      contentType: PLPConstants.contentType,
    };

    if (this.recent_applied_facet_category != '') {
      count_filter_query[
        this.recent_applied_facet_category
      ] = this.applyedFilterList[0].filter[this.recent_applied_facet_category];
    }
    this.setUrlhashString(url_hash_string);
  };

  getInitialFacetCount = () => {
    /**
     * Get facet count for current applied category
     */

    let product_search_query = Object.assign({}, this.algoliaQuery);
    product_search_query.facets = this.facet_category_list;

    getFilteredData(this.initial_products,{...product_search_query,...PLPConstants.sorting_dropdown_list['newest']})
      .then((data) => {
        
          this.product_section_loader = false;
          if (data.page >= data.nbPages-1) {
            this.load_more_display_state = false;
          }
          const facet_count_object = data.facets;

          this.setFacetCount(facet_count_object);

      })
      .catch(() => {
        this.product_section_loader = false;
      });
  };

  setUrlhashString = hash_string => {
    this.url_hash_string = hash_string;
    if (typeof window !== 'undefined' && hash_string.length > 0) {
      if (this.applyedFilterList[0].page > 1) {
        window.history.replaceState(
          '',
          document.title,
          this.pageSlug + '-page-' + this.applyedFilterList[0].page
        );
      } else if (this.applyedFilterList[0].page === 1) {
        window.history.replaceState('', document.title, this.pageSlug);
      }
    } else if (typeof window !== 'undefined' && hash_string === '') {
      if (this.applyedFilterList[0].page !== 1) {
        window.history.replaceState('', document.title, location.pathname);
      } else {
        window.history.replaceState('', document.title, this.pageSlug);
      }
    }
  };

  /**
   * Set facet count based on swiftype data
   */
  setFacetCount = facet_count_list => {
    const facet_categories = Object.keys(facet_count_list);
    for (let index = 0; index < facet_categories.length; index++) {
      const category_unique_id = facet_categories[index];
      const category_facet_count_list = facet_count_list[category_unique_id];

      let matched_facet_category = this.filters.facetCategories.filter(
        category => {
          return category.title === category_unique_id;
        }
      );

      if (
        matched_facet_category.length &&
        matched_facet_category[0].facet.length
      ) {
        for (let j = 0; j < matched_facet_category[0].facet.length; j++) {
          if (
            category_facet_count_list.hasOwnProperty(
              matched_facet_category[0].facet[j].title.trim()
            ) &&
            matched_facet_category[0].facet[j].facet_category !=
              this.recent_applied_facet_category
          ) {
            matched_facet_category[0].facet[j].product_count =
              category_facet_count_list[
                `${matched_facet_category[0].facet[j].title.trim()}`
              ];
          } else {
            if (
              matched_facet_category[0].facet[j].facet_category !=
              this.recent_applied_facet_category
            ) {
              matched_facet_category[0].facet[j].product_count = 0;
            }
          }
        }
      }
    }
  };

  resetStore() {
    this.product_list = [];
    this.selected_product_ids = [];
    this.locale = '';
    this.pageData = {};
    this.initial_products = [];
    this.lazyLoad = { ...PLPConstants.lazy_load_consts };
    this.recent_applied_facet_category = '';
    this.filters = [];
    this.selectedFilters = [];
    this.facet_category_list = [];
    this.product_section_loader = false;
    this.load_more_display_state = true;
    this.url_hash_string = '';
    this.previous_query = '';
  }
}
export default new PLPStore();
